module["exports"] = [
  "#",
  "##",
  "###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/address/building_number.js
// module id = 1545
// module chunks = 0